'use strict';

bbw.model.Contest = ngtk.model.Item.extend({

    $q: undefined,

    $inject: ['modelFactory', 'rpcClient', '$q'],

    _forAdmin: false,
    _votes: undefined,

    statics: {
        allowedGenders: [
            {value: 'm', label: 'парни'},
            {value: 'f', label: 'девушки'},
        ]
    },

    construct: function(modelFactory, rpcClient, $q) {
        this._api = rpcClient;
        this._modelFactory = modelFactory;
        this.$q = $q;
        this._initialize();
    },

    loadDefaults: function() {
        this.ensureIsForAdmin();
        return this._api.get('admin/contests/defaults').execute().then(function(response) {
            this.merge(response.defaults);
        }.bind(this));
    },

    loadVotes: function() {
        return this._api.get('contest/votes/' + this.get('id')).execute().then(function(response) {
            this.merge({votes: response.votes});
            this._votes = this._data.votes;
        }.bind(this));
    },

    /**
     * @param contestParticipantId
     * @param photoId
     * @returns {{vote: int|null, processing: boolean}}
     */
    getPhotoVoteScore: function(contestParticipantId, photoId) {
        if (!this._votes) {
            throw new Error("Votes not loaded");
        }
        if (this._votes[contestParticipantId] && this._votes[contestParticipantId][photoId]) {
            return this._votes[contestParticipantId][photoId];
        }
        return {vote: null, processing: false};
    },

    updateLogo: function(logo) {
        this.merge({logo: logo, can_publish_draft: true});
    },

    updatePhotoExample: function(isVerification, photoExample) {
        if (angular.isObject(this._data.photo_example)) {
            this._data.photo_example = {};
        }
        this._data.photo_example[isVerification ? 'verification' : 'contest'] = photoExample;
    },

    toggleVote: function(contestParticipantId, photoId, vote) {
        if (this.getPhotoVoteScore(contestParticipantId, photoId).vote == vote) {
            vote = null;
        }
        return this.vote(contestParticipantId, photoId, vote);
    },

    vote: function(contestParticipantId, photoId, vote) {
        if (vote) {
            vote = parseInt(vote);
            if (isNaN(vote)) {
                throw new Error("Invalid vote value");
            }
        }
        if (!vote) {
            vote = null;
        }
        var origScore = this.getPhotoVoteScore(contestParticipantId, photoId);
        if (origScore.processing) {
            return this.$q.when();
        }
        this._updatePhotoVoteScore(contestParticipantId, photoId, vote, true);
        return this._api.post('contest/vote', {
            contest_id: this.get('id'),
            participant_id: contestParticipantId,
            photo_id: photoId,
            vote: vote
        }).execute().then(function(response) {
            this._updatePhotoVoteScore(contestParticipantId, photoId, vote);
            this._updateParticipant(response.participant);
            return response;
        }.bind(this)).catch(function(error) {
            this._updatePhotoVoteScore(contestParticipantId, photoId, origScore.vote);
            return this.$q.reject(error);
        }.bind(this));
    },

    _updateParticipant: function(participantUpdate) {
        if (angular.isArray(this._data.participants)) {
            this._data.participants.some(function(participant) {
                if (participant.id == participantUpdate.id) {
                    angular.extend(participant, participantUpdate);
                    return true;
                }
            })
        }
    },

    _updatePhotoVoteScore: function(contestParticipantId, photoId, vote, processing) {
        if (!this._votes) {
            throw new Error("Votes not loaded");
        }
        if (!vote && !processing) {
            if (this._votes[contestParticipantId]) {
                if (this._votes[contestParticipantId][photoId]) {
                    delete this._votes[contestParticipantId][photoId];
                }
                if (Object.keys(this._votes[contestParticipantId]).length == 0) {
                    delete this._votes[contestParticipantId];
                }
            }
        } else {
            if (!this._votes[contestParticipantId]) {
                this._votes[contestParticipantId] = {};
            }
            this._votes[contestParticipantId][photoId] = {vote: vote, processing: !!processing};
        }
    },

    makeParticipantModel: function() {
        return this._modelFactory.create(bbw.model.ContestParticipant).setContestId(this.get('id'));
    },

    forAdmin: function(isForAdmin) {
        this._forAdmin = angular.isUndefined(isForAdmin) ? true : !!isForAdmin;
        return this;
    },

    initializeNew: function() {
        this._data.status = 'draft';
        return this.loadDefaults();
    },

    load: function(id, withParticipants) {
        var method = this._forAdmin ? 'admin/contests/{id}' : 'contest/{id}';
        if (withParticipants) {
            method += '/1';
        }
        return this._loadFromApi('get', method, {id: id}).then(function(response) {
            this._setFromApiResult(response.contest);
        }.bind(this));
    },

    reload: function() {
        return this.load(this.get('id'));
    },

    store: function() {
        this.ensureIsForAdmin();
        if (this.get('id')) {
            return this.save();
        } else {
            return this.create();
        }
    },

    publish: function() {
        this.ensureIsForAdmin();
        return this._api.post('admin/contests/publish', {id: this._data.id}).execute().then(function(result) {
            this.merge({status: result.status});
        }.bind(this));
    },

    cancel: function() {
        this.ensureIsForAdmin();
        return this._api.post('admin/contests/cancel', {id: this._data.id}).execute().then(function(result) {
            result.status && this.merge({status: result.status});
        }.bind(this));
    },

    nextState: function() {
        this.ensureIsForAdmin();
        return this._api.post('admin/contests/force-next-state', {id: this._data.id}).execute().then(function(result) {
            result.status && this.merge({status: result.status});
        }.bind(this));
    },

    create: function() {
        this.ensureIsForAdmin();
        return this._api.post('admin/contests/create', this._data).execute().then(function(result) {
            if (result.id) {
                this.merge({id: result.id});
            }
        }.bind(this));
    },

    save: function() {
        this.ensureIsForAdmin();
        return this._api.post('admin/contests/edit', this._data).execute();
    },

    deleteDraft: function() {
        this.ensureIsForAdmin();
        if (!this._data.id) {
            throw new Error('id is undefined');
        }
        if (this.get('status') != 'draft') {
            return this.$q.reject('cannot_delete_contest_not_draft');
        }
        return this._api.post('admin/contests/delete', {id: this._data.id}).execute();
    },

    ensureIsForAdmin: function() {
        if (!this._forAdmin) {
            throw new Error("Access denied");
        }
    },

    _extractIdFromItemData: function(itemData) {
        return itemData.id;
    }

});
